var TabsComponent = $.extend({/* TabsComponent */}, BaseComponent, {

	componentSelector: '.tabs-component',

	init: function() {
		$(this.componentSelector).each(this.binding.bind(this));
	},	

	binding: function(index, element) {

		$(element).find('.select-navigation-mobile').siblings('.active-tab').click((function(event) {
			$(event.currentTarget).siblings('.select-navigation-mobile').slideToggle(500);

			if ($(event.currentTarget).find('i').hasClass('icon-flecha_circulo_down')) {
				$(event.currentTarget).find('i').removeClass('icon-flecha_circulo_down');
				$(event.currentTarget).find('i').addClass('icon-flecha_circulo_up');
			}
			else if ($(event.currentTarget).find('i').hasClass('icon-flecha_circulo_up')) {
				$(event.currentTarget).find('i').removeClass('icon-flecha_circulo_up');
				$(event.currentTarget).find('i').addClass('icon-flecha_circulo_down');
			}			
		}).bind(this));

		$(element).find('.select-navigation-mobile').find('.option-navigation-mobile').click((function(event) {
			var optionValue = $(event.currentTarget).text() + '<i class="icon-flecha_circulo_down"></i>';
			$(element).find('.select-navigation-mobile').siblings('.active-tab').html(optionValue);
			
			var selectedIndex = $(event.currentTarget).index();
			var anchor = $(event.currentTarget).parents('.tabs-component').find('.navigation-tabs-desktop a')[selectedIndex];

			if (!$(anchor).hasClass('active')) {
				window.location = $(anchor).attr('href');
			}
		}).bind(this));

	}
})